import React, { useEffect, useRef, useState } from "react";

import {
  StyledGalleryWrap
} from './StyledGalleryThumbs';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
const GalleryThumbs3d = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleCLick = (slug) => {
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
  }
  return (
    <React.Fragment>
      <StyledGalleryWrap>
        <div className="thumb-cell" onClick={() => handleCLick('/3d-commerce-experience/item-1')}>
          <p className="preset-11 thumb-title">FASHION</p>
          <iframe src="/3d-objects/thumbs.html?VELASCA" frameBorder="0"></iframe>
          <p className="thumb-subtitle">
            <img src={require('../../assets/gesture-manina.svg')} />
            <span>click & hold to rotate</span>
          </p>
          <div className="thumb-hover-wrap">
            <div className="thumb-copy">
              <p className="preset-12">Elegant</p>
              <p className="preset-13">Ultra-realistic 3D elegant shoes </p>
              <div className="end-row">
                <p className="preset-13">&euro; 123,00</p> 
                <img src={require('../../assets/3dexperience/rating.jpg')} />
              </div>
            </div>
            <div className="thumb-hover">
              <p className="preset-12">
                VIEW MORE
              </p>
            </div>
          </div>
        </div>
        <div className="thumb-cell" onClick={() => handleCLick('/3d-commerce-experience/item-2')}>
          <p className="preset-11 thumb-title">ACCESSORIES</p>
          <iframe src="/3d-objects/thumbs.html?FENDI" frameBorder="0"></iframe>
          <p className="thumb-subtitle">
            <img src={require('../../assets/gesture-manina.svg')} />
            <span>click & hold to rotate</span>
          </p>
          <div className="thumb-hover-wrap">
            <div className="thumb-copy">
              <p className="preset-12">Iconic</p>
              <p className="preset-13">We want to get fashion ready for a high-bandwidth world </p>
              <div className="end-row">
                <p className="preset-13">&euro; 4.321,00</p> 
                <img src={require('../../assets/3dexperience/rating.jpg')} />
              </div>
            </div>
            <div className="thumb-hover">
              <p className="preset-12">
                VIEW MORE
              </p>
            </div>
          </div>
        </div>
        <div className="thumb-cell" onClick={() => handleCLick('/3d-commerce-experience/item-3')}>
          <p className="preset-11 thumb-title">DESIGN</p>
          <iframe src="/3d-objects/thumbs.html?KNOLL" frameBorder="0"></iframe>
          <p className="thumb-subtitle">
            <img src={require('../../assets/gesture-manina.svg')} />
            <span>click & hold to rotate</span>
          </p>
          <div className="thumb-hover-wrap">
            <div className="thumb-copy">
              <p className="preset-12">Smart</p>
              <p className="preset-13">Full Reality 3D design models</p>
              <div className="end-row">
                <p className="preset-13">&euro; 456,00</p> 
                <img src={require('../../assets/3dexperience/rating.jpg')} />
              </div>
            </div>
            <div className="thumb-hover">
              <p className="preset-12">
                VIEW MORE
              </p>
            </div>
          </div>
        </div>
        <div className="thumb-cell" onClick={() => handleCLick('/3d-commerce-experience/item-4')}>
          <p className="preset-11 thumb-title">CPG</p>
          <iframe src="/3d-objects/thumbs.html?BARILLA" frameBorder="0"></iframe>
          <p className="thumb-subtitle">
            <img src={require('../../assets/gesture-manina.svg')} />
            <span>click & hold to rotate</span>
          </p>
          <div className="thumb-hover-wrap">
            <div className="thumb-copy">
              <p className="preset-12">Useful</p>
              <p className="preset-13">Tailor made CPG experiences that fit your specific business</p>
              <div className="end-row">
                <p className="preset-13">&euro; 12,30</p> 
                <img src={require('../../assets/3dexperience/rating.jpg')} />
              </div>
            </div>
            <div className="thumb-hover">
              <p className="preset-12">
                VIEW MORE
              </p>
            </div>
          </div>
        </div>

      </StyledGalleryWrap>
    </React.Fragment>
  )
}

export default GalleryThumbs3d;